import { GAM_SOURCES } from '@ldp/media-utils';
import { ISDMProductTileData } from '@ldp/common-types';

export const appendSourceQueryToProductLink = (
  isComplementary?: boolean,
  isSponsored?: boolean,
  link?: string,
  url: string = ''
) => {
  const IS_SSR = typeof window === 'undefined';

  if (!IS_SSR && !url) {
    url = window?.location.pathname;
  }
  let pdpSource = GAM_SOURCES.OTHER;

  if (!isSponsored) {
    pdpSource = 'nspt';
  } else {
    pdpSource = isComplementary ? 'sptc' : 'sptd';
  }

  if (checkIfIsCollectionsPage(url)) {
    pdpSource = GAM_SOURCES.OTHER;
  } else if (checkIfIsPageBrandHub(url)) {
    pdpSource = GAM_SOURCES.BRAND_HUB;
  } else if (checkIfIsPageEditorial(url)) {
    pdpSource = GAM_SOURCES.UNSET;
  } else if (checkIfIsPageBrandPlp(url)) {
    pdpSource = GAM_SOURCES.BRAND_PLP;
  }

  const updatedLink = link?.includes('?') ? `${link}&source=${pdpSource}` : `${link}?source=${pdpSource}`;

  return updatedLink;
};

export const updateProductTiles: ISDMProductTileData[] | any = (productTiles: ISDMProductTileData[], entries: any) => {
  return productTiles?.map((product) => {
    const { isComplementarySponsored, isSponsored, link } = product;
    const updatedLinkWithSource = appendSourceQueryToProductLink(isComplementarySponsored, isSponsored, link);
    return {
      ...product,
      quantity: entries[product.productId]?.quantity || 0,
      link: updatedLinkWithSource,
    };
  });
};

export const checkIfIsCollectionsPage = (url: string) => {
  const collections = ['featuredcollections', 'collections', 'thoughtful-choices'];
  return collections.some((keyword) => url.toLowerCase().includes(keyword));
};

export const checkIfIsPageEditorial = (url: string) => url.includes('/editorials/');

export const checkIfPageIsCategory = (url: string) => url.includes('/categories/');

export const checkIfIsPageBrandPlp = (url: string) => {
  const regTest = /\/shop\/[^/]+\/c\/[^/\n]+/;
  return !checkIfPageIsCategory(url) && regTest.test(url);
};

// communicated with Kristen C.
// expectation is that all brandhub pages will have /brand/ in their url
// and changes to this will be communicated to Ads GTM team
// https://loblaw.slack.com/archives/G01J150M153/p1728586135477199
export const checkIfIsPageBrandHub = (url: string) => url.includes('/brand/');
